export const isAiThinkingTerminalStep = (step?: string | null, stepKey?: string | null): boolean => {
  const normalizedKey = stepKey?.trim().toLowerCase();
  if (normalizedKey) {
    const canonicalKey = normalizedKey.replace(/[\s_-]+/g, '.');
    if (
      canonicalKey === 'reply.ready'
      || canonicalKey === 'reply.done'
      || canonicalKey === 'reply.failed'
      || canonicalKey === 'reply.skipped'
      || canonicalKey === 'draft.done'
      || canonicalKey === 'draft.empty'
      || canonicalKey === 'draft.failed'
      || canonicalKey === 'summary.done'
      || canonicalKey === 'summary.empty'
      || canonicalKey === 'summary.failed'
    ) {
      return true;
    }

    return canonicalKey.endsWith('.failed')
      || canonicalKey.endsWith('.error')
      || canonicalKey.endsWith('.cancelled')
      || canonicalKey.endsWith('.canceled');
  }

  const normalized = step?.trim().toLowerCase();
  if (!normalized) {
    return false;
  }

  const canonical = normalized.replace(/[\s_-]+/g, '.');

  return canonical === 'reply.ready'
    || canonical.endsWith('.ready')
    || canonical.endsWith('.done')
    || canonical.endsWith('.complete')
    || canonical.endsWith('.completed')
    || canonical.endsWith('.finished')
    || canonical.endsWith('.failed')
    || canonical.endsWith('.error')
    || canonical.endsWith('.cancelled')
    || canonical.endsWith('.canceled');
};
